export interface UserAttributeModel {
    email: string
}